import React from "react";
import { useArena } from "core/components/ArenaProvider";
import NoMatchScreen from "arena/components/NoMatchScreen";
import { useLocation } from "react-router-dom";
import PageHelmet from "./PageHelmet";
import PageSection from "./PageSection";
import usePageview from "core/hooks/usePageview";
import LoadingScreen from "core/components/LoadingScreen";
import ErrorScreen from "core/components/ErrorScreen";
import { useQuery } from "@apollo/client";
import { ArenaPageQuery } from "arena/queries";
import ProxyPage from "arena/components/ProxyPage/ProxyPage";

const COVER = "COVER";
const COVER_CAROUSEL = "COVER_CAROUSEL";

/**
 * Функция принимает массив блоков для страницы и возвращает массив блоков
 * в котором блоки типа "Обложка" сгруппированы в карусельку.
 */
function groupBlocks(blocks) {
  const result = [];

  blocks.forEach((block) => {
    const last = result[result.length - 1];

    if (block.component === COVER) {
      if (last?.component === COVER_CAROUSEL) {
        last.props.blocks.push(block);
      } else {
        result.push({
          id: block.id,
          component: COVER_CAROUSEL,
          props: {
            blocks: [block],
          },
        });
      }
    } else {
      result.push(block);
    }
  });

  return result;
}

export default function Page() {
  const arena = useArena();
  const location = useLocation();

  const { data, previousData, loading, error } = useQuery(ArenaPageQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      path: location.pathname,
    },
  });

  const page = data !== undefined ? data?.page : previousData?.page;
  const arenaProxyPage =
    data !== undefined ? data?.arenaProxyPage : previousData?.arenaProxyPage;

  usePageview(location.pathname, arenaProxyPage?.title || page?.title);

  if (loading && data === undefined) return <LoadingScreen />;

  if (error) return <ErrorScreen error={error} />;

  if (!page && !arenaProxyPage) {
    return <NoMatchScreen />;
  }

  /**
   * Прокси-страница и обычная страница ищутся по одному и тому же пути, и
   * теоретически на нём могут найтись обе. Прокси-страница главнее: её
   * адрес заведён под конкретный контент, а блоки страницы иначе встали бы
   * вторым слоем под ним.
   */
  if (arenaProxyPage) {
    return <ProxyPage arenaProxyPage={arenaProxyPage} />;
  }

  const blocks = page ? groupBlocks(page.blocks) : [];

  return (
    <>
      {page && (
        <>
          <PageHelmet arena={arena} page={page} />
          {blocks.map((block, index) => (
            <PageSection
              block={block}
              arena={arena}
              index={index}
              first={index === 0}
              last={index + 1 === blocks.length}
              key={block.id}
            />
          ))}
        </>
      )}
    </>
  );
}
